<template>
  <LoginLayout>
    <RoutineLogoIcon :is-colored="true" class="logo" />
    <section>
      <div class="block">
        <img alt="google-icon" src="../../assets/apps/google.svg" />
        <p>
          Every Routine app is verified by Google, having been through a
          thorough validation process.
        </p>
      </div>
      <hr />
      <div class="block">
        <img alt="transfer-icon" src="../../assets/transfer.svg" />
        <p>
          Data exchanges with Google and third-party services (Notion, Slack,
          Gmail etc.) do not involve Routine’s servers; data flows between your
          device and their servers.
        </p>
      </div>
      <hr />
      <div class="block">
        <img alt="lock-icon" src="../../assets/lock.svg" />
        <p>
          All communication from your devices is encrypted to ensure the safety
          of your data.
        </p>
      </div>
    </section>
    <p class="sm">
      Learn how the
      <BaseLink
        size="small"
        @click="openUrl('https://routine.co/integrations/services/gmail')"
      >
        Gmail permission
      </BaseLink>
      you grant Routine is used.
    </p>
    <BaseButton
      kind="important"
      :text="buttonText"
      :state="googleFlowStarted ? 'disabled' : 'default'"
      true-colors-icon
      @click="$emit('startGoogleFlow')"
    >
      <template #icon>
        <GoogleIcon />
      </template>
    </BaseButton>
  </LoginLayout>
</template>

<script lang="ts">
import { defineComponent } from "vue";

import GoogleIcon from "@/components/icons/apps/google/GoogleIcon.vue";
import { openExternalUrl } from "@/utils/open-external-url";

import BaseButton from "../base/BaseButton.vue";
import BaseLink from "../base/BaseLink.vue";
import RoutineLogoIcon from "../icons/RoutineLogoIcon.vue";
import LoginLayout from "./LoginLayout.vue";

export default defineComponent({
  components: {
    BaseButton,
    BaseLink,
    LoginLayout,
    RoutineLogoIcon,
    GoogleIcon,
  },

  props: {
    buttonText: { type: String, required: true },
    googleFlowStarted: { type: Boolean, required: true },
  },

  emits: {
    startGoogleFlow: () => true,
  },

  setup() {
    const openUrl = (url: string) => openExternalUrl(url, null, false);

    return {
      openUrl,
    };
  },
});
</script>

<style lang="scss" scoped>
.logo {
  margin-bottom: 48px;
}

section {
  max-width: 380px;
  display: flex;
  flex-direction: column;
  row-gap: 4px;

  .block {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    column-gap: 8px;
    padding-bottom: 24px;
    @include themed() {
      border-bottom: 1px solid t($grey-10);
    }
  }
}
p.sm {
  margin: 16px 0 32px 0;
}
</style>
